<template>
  <div class="container">
    <div class="inner">
      <r-title>{{ $t('referral.page.description.header') }}</r-title>
      <p v-html="$t('referral.page.description')"></p>
      <a @click="handleTermsClick" class="terms">{{ $t('read.terms') }}</a>
    </div>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
import RTitle from '@/components/common/Title.vue';
import TermsModal from './TermsModal.vue';

export default {
  components: {
    RTitle,
  },
  methods: {
    handleTermsClick(e) {
      e.preventDefault();
      Modal.info({
        title: this.$t('terms.short'),
        content: (h) => h(TermsModal),
        width: 600,
        class: 'terms-dialog',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';

.container {
  width: 100%;
  background-color: rgba($footer, 0.5);
}

.inner {
  padding: 5%;
  max-width: 800px;
  font-size: $font-size-large;
}

p {
  margin: 20px;
}
</style>

<style lang="scss">
.terms-dialog {
  ol {
    text-align: left;
  }
}
</style>